module.exports = __webpack_public_path__ + "img/cedi-sign.49d7c91b.svg";